import React, { useContext, useEffect, useState } from "react";
import arePropsEqual from "react-fast-compare";
import { Checkbox } from "@mui/material";

//context
import { ReviewAndPayContext } from "../../ReviewAndPayContext";

const SelectAllPaysRows = () => {
	const context = useContext(ReviewAndPayContext);

	const [checked, setChecked] = useState<boolean>(false);

	useEffect(() => {
		if (!context.selectedRows.length) {
			setChecked(false);
		}
		if (context.selectedRows.length === context.rows.length) {
			setChecked(true);
		} else {
			setChecked(false);
		}
	}, [context.selectedRows, context.rows]);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(event.target.checked);
		if (event.target.checked) {
			context.setSelectedRows(context.rows);
		} else {
			context.setSelectedRows([]);
		}
	}

	return (
		<>
			<Checkbox
				size="small"
				sx={{ padding: '4px' }}
				checked={checked}
				onChange={handleChange}
				inputProps={{ 'aria-label': 'controlled' }}
			/>
		</>
	);
};

export default React.memo(SelectAllPaysRows, arePropsEqual);
